// src/components/styles.ts

export const section4Styles: React.CSSProperties = {
    // Your styles for the section container
  };
  
  export const section4InfoStyles: React.CSSProperties = {
    // Your styles for the section info container
  };
  
  export const h2Styles: React.CSSProperties = {
    // Your styles for h2 elements
    fontSize: '24px', // Increase the font size to 24 pixels (adjust as needed)
  };
  
  export const sectionDescriptionStyles: React.CSSProperties = {
    // Your styles for section description
  };
  
  export const mealsGridStyles: React.CSSProperties = {
    // Your styles for meals grid container
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)', // Display 3 columns per row
    gap: '20px', // Adjust the gap between containers
  };
  
  export const mealItemStyles: React.CSSProperties = {
    // Your styles for each meal item
    marginBottom: '20px', // Add margin to separate meal items vertically
    marginLeft: '5px', // Add margin to the left to control horizontal spacing
    marginRight: '20px', // Add margin to the right to control horizontal spacing
    display: 'flex',
    backgroundColor: 'black', // Black background for the container
    color: 'white', // Text color
    padding: '10px', // Padding inside the container
    borderRadius: '5px', // Add some border radius for rounded corners
    maxWidth: '350px', // Adjust the maximum width of the container to make it smaller
  };
  
// src/components/styles.ts

export const mealItemImageStyles: React.CSSProperties = {
  // Your styles for meal item images
  maxWidth: '100%', // Set the maximum width to maintain aspect ratio
  height: '200px', // Set a fixed height for all images (adjust as needed)
  objectFit: 'cover', // Ensure the image covers the container without stretching
  marginRight: '20px', // Add margin to space the image from text
};

  
  export const mealItemDetailsStyles: React.CSSProperties = {
    // Your styles for meal item details container
    flex: 1, // Expand to fill available space
  };
  
  export const mealItemOrderStyles: React.CSSProperties = {
    // Your styles for meal item order container
  };
  
  export const mealItemOrderPStyles: React.CSSProperties = {
    // Your styles for the paragraph inside meal item order container
    fontSize: '18px', // Increase the font size to 18 pixels (adjust as needed)
  };
  
  export const mealItemOrderAStyles: React.CSSProperties = {
    // Your styles for the link at the bottom
  };
  